import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
} from '@angular/core';
import { IconComponent } from '../../atoms/icon/icon.component';
import { TooltipDirective } from '@ui';
import { TranslocoDatePipe } from '@jsverse/transloco-locale';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-time-indicator',
  imports: [IconComponent, TooltipDirective, TranslocoDatePipe],
  template: `
    <div
      uiTooltip
      [tooltipTitle]="tooltipTitleTemplate"
      class="flex justify-center items-center"
    >
      <ui-icon icon="clock-circle" class="text-md" />
    </div>

    <ng-template #tooltipTitleTemplate let-data>
      <span class="text-xs">
        {{
          timestamp()
            | translocoDate: { dateStyle: 'short', timeStyle: 'medium' }
        }}
      </span>
    </ng-template>
  `,
})
export class TimeIndicatorComponent {
  timestamp = input.required<number>();
}
